import { useMediaQuery } from "usehooks-ts";
import ToolTips from "utils/toolTips";
import { useAppSelector } from "../../../redux/hooks";
import { useLocation } from "react-router-dom";

interface Props {
  metricName?: string;
}

const TotalSalesVendorWarning = ({ metricName }: Props) => {
  const toolTipIconMinWidth = useMediaQuery("(min-width:1000px)");
  const toolTipIconMaxWidth = useMediaQuery("(max-width:1500px)");
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const orgType = useAppSelector((state) => state.user.organization_type);
  const { pathname } = useLocation();

  if (channel !== "amazon" || orgType !== "vendor" || metricName !== "Sales" || pathname.includes("dsp")) {
    return null;
  }

  return toolTipIconMaxWidth && toolTipIconMinWidth ?
      <span style={{ position: "absolute", left: "20px", color: "yellow" }}>
        <ToolTips
          icon="fa fa-warning"
          toolTip="Total sales stats may be delayed by 3-7 days for vendors"
          id="vendorTotalSalesWarning"
        />
      </span>
    : <div
        style={{
          position: "absolute",
          left: "15px",
          width: "35%",
          fontSize: "10px",
          textAlign: "initial",
        }}
      >
        <p
          style={{
            fontSize: "10px",
            textTransform: "none",
          }}
        >
          <i className="fa fa-warning fa-sm text-muted" />
          Total sales stats may be delayed by 3-7 days for vendors
        </p>
      </div>;
};

export default TotalSalesVendorWarning;
